module.exports = __webpack_public_path__ + "media/img/frontend_application/eventtype/birthday-486909b41385971249ce388a64846ebc.jpg";